import {MoreVo} from '../../common/shared/api/karina/vo/MoreVo.interface';
import {ReferenceVo} from '../../common/shared/api/karina/vo/reference/ReferenceVo.interface';
import {TabVo} from '../../common/shared/api/karina/vo/TabVo.interface';
import {ViewDataVo} from '../../common/shared/api/karina/vo/ViewDataVo.interface';
import {
  Group,
  Maybe,
  SectionSubTab,
  SectionType,
  User,
} from '../generated/types';
import {createGroupWithViewDataVo} from './Group';

/**
 * 탭이 있는 섹션의 서브탭(요일연재면 요일탭(월~일))별로 group 이 할당됩니다.
 * 이 함수는 서버에서 받은 데이터 기반으로 그룹을 만들어 요일탭에 할당해주는 함수입니다.
 */
export function createSectionSubTabListAndGroups(
  userInfo: Maybe<User>,
  {
    view_data,
    section_tab_list,
    selectedSubTabUid,
    reference,
    more,
    sectionType,
    sectionId,
  }: {
    view_data?: ViewDataVo;
    section_tab_list?: TabVo[];
    selectedSubTabUid?: number;
    reference?: ReferenceVo;
    more?: MoreVo;
    sectionType: SectionType;
    additional_string?: string;
    sectionId: string;
  }
): {sectionSubTabList: SectionSubTab[]; groups: Group[]} {
  const sectionSubTabList: SectionSubTab[] = [];
  const groups: Group[] = [];
  // 메인랭킹 경우엔 메인탭만 존재할 수 있습니다. 이 경우 하나의 가상의 서브탭을 넣어줍니다
  if (view_data) {
    const contentViewGroup = createGroupWithViewDataVo(userInfo, {
      view_data,
      reference,
      more,
      sectionType,
      sectionId,
    });
    sectionSubTabList.push({
      uid: selectedSubTabUid || 0,
      isSelected: true,
      groupId: contentViewGroup.id,
    });
    groups.push(contentViewGroup);
  } else {
    section_tab_list?.forEach(leafTabVo => {
      // 반드시 leaf tab vo 엔 view_data 가 존재해야한다
      if (!leafTabVo.view_data) {
        console.error('leaf vo 에 view_data 가 없음. ');
        throw new Error('잘못된 데이터입니다');
      }
      const contentViewGroup = createGroupWithViewDataVo(userInfo, {
        view_data: leafTabVo.view_data,
        reference,
        more,
        sectionType,
        sectionId,
      });
      sectionSubTabList.push({
        uid: leafTabVo.tab_uid,
        title: leafTabVo.title,
        isSelected: leafTabVo.tab_uid === selectedSubTabUid,
        groupId: contentViewGroup.id,
      });
      groups.push(contentViewGroup);
    });
  }
  return {sectionSubTabList, groups};
}
